import { useEffect, useRef, useState } from 'react'
import { useNavigate } from 'react-router';
import { useDispatch, useSelector } from 'react-redux'
import { Table, Tag, Dropdown, Button, message, Flex, QRCode, Modal } from 'antd'
import {
    // DownloadOutlined,
    EditOutlined,
    // QrcodeOutlined,
    VideoCameraOutlined,
    CloseOutlined
} from '@ant-design/icons';

// Config
import { APP_CONFIG } from '../../../../config';

// Constants
import { TEMPLATE } from '../../../../constants'

// Components
import { EmptyIndicator } from '../../../../components/Indicator'
// import { VehiclePackageLabel, VehiclePackageStatus } from '../../../../components/VehiclePackage'
// import { VehiclePackageLabel } from '../../../../components/VehiclePackage'
import { PrimaryButton } from '../../../../components/Decoration/Button';
import ModalStandard from '../../../../components/ModalStandard';
// import DrawerWrapper from '../../../../components/DrawerWrapper';
import VehiclePlateECUTag from '../../../../components/VehiclePlateECUTag'
import Loading from '../../../../components/Loading'
import SVG from '../../../../components/SVG';

// Services
import { TIME, REDUX } from '../../../../services/util'

// Handler
import {
    table_handler,
    vehicles_handler,
    templateHDLR,
    uploadHDLR,
    xlsx_handler,
    pdf_handler
} from '../../../../handlers'

// Redux Actions
import * as REDUX_ACTIONS from '../../../../services/redux/actions'

// Style
import styles from '../index.module.css'

const { getColumnSearchProps } = table_handler
const { vehicleECUValidator } = vehicles_handler
const { parseDate } = TIME

const {
    STATUS_LABEL
} = TEMPLATE.VEHICLE

const {
    FMS_V3_FE_LIVE_TRACKING_URL
} = APP_CONFIG

const VehiclePanel = () => {

    const navigate = useNavigate()
    const dispatch = useDispatch()

    const { uid } = useSelector(REDUX.reduxStoreWrapper('user'))
    const vehicleStaticses = useSelector(REDUX.reduxStoreWrapper('vehicles.staticsByID'))
    const vehicleStates = useSelector(REDUX.reduxStoreWrapper('vehicles.stateByID'))
    const vehicleFuelProfiles = useSelector(REDUX.reduxStoreWrapper('vehicles.fuelProfileByID'))
    const vehiclePackageProfiles = useSelector(REDUX.reduxStoreWrapper('vehicles.vehiclePKGByID'))
    const vehicleGroups = useSelector(REDUX.reduxStoreWrapper('vehicleGroups'))
    // const vehiclePackages = useSelector(REDUX.reduxStoreWrapper('subscriptionPackages.vehiclePKGByID')) 
    // const allVPKGIDs = useSelector(REDUX.reduxStoreWrapper('subscriptionPackages.allVehiclePKGIDs'))
    const allVGIDs = useSelector(REDUX.reduxStoreWrapper('vehicleGroups.allIDs'))
    
    const users = useSelector(REDUX.reduxStoreWrapper('userHierarchy.byID'))

    const curUserRole = useSelector(REDUX.reduxStoreWrapper('user.uroleid'))
    const loading = useSelector(REDUX.reduxStoreWrapper('style.loading.vehicle'))

    const [ dataSource, setDataSource ] = useState([])
    const [ isLoaded, setIsLoaded ] = useState(false);
    const [ qrContent, setQRContent ] = useState(false)
    
    const searchTextState = useState('')
    const searchedColumnState = useState('')

    const usePrevious = (value) => {
        const ref = useRef();
        useEffect(() => {
          ref.current = value;
        });
        return ref.current;
    }

    const prevVehicles = usePrevious(vehicleStaticses);

    const refreshDataSrc = () => {
        const newDataSource = Object.values(vehicleStaticses)
            .sort((b, a) => b.plate - a.plate)
            .map(vehicleStatics => {
                const vid = vehicleStatics.vid
                const dvid = vehicleStatics.dvid
                const vehiclePackage = vehiclePackageProfiles[vid]
                const vehicleECU = vehicleECUValidator(vehicleStates[vid])
                const vehicleFuelProfile = vehicleFuelProfiles[vid]
                const vehicleState = vehicleStates[vid]
                const imei = dvid?.split('#')[1] || vehicleStatics.imei


                let vhcgids =  vehicleStatics.vhcgids || vehicleGroups.allIDs.filter(vhcgid => vehicleGroups.byID[vhcgid].vehicles && vehicleGroups.byID[vhcgid].vehicles.includes(vid))
                vhcgids = vhcgids.length ? vhcgids : [`vhcg#${uid}`] 

                return {
                    key: vid,
                    vpkgids: vehiclePackage?.vpkgids || [],
                    ...vehicleStatics,
                    ...vehicleState,
                    ...vehicleECU,
                    fuelProfile: vehicleFuelProfile,
                    vhcgids,
                    imei: imei || vehicleStatics.imei,
                    fuel_sensor: vehicleFuelProfile ? 1 : 0,
                    gnss_status: imei ? 1 : 0,
                    status: vehicleStatics.status || 0,
                    registeredAt: vehicleStatics.registeredAt || vehicleStatics.createdAt,
                    mdvr: (vehicleStatics.mdvrid) && (vehicleStatics.mdvrid !== '') && (vehicleStatics.mdvrid !== '-') ? 1 : 0
                }
            })

        setDataSource(newDataSource)
    }

    const vehiclePanelColumns = [
        {
          title: "Vehicle Plate",
          dataIndex: "plate",
          fixed: 'left',
          ...getColumnSearchProps("Vehicle Plate", 'plate', searchTextState, searchedColumnState, (plate, vehicle) => <VehiclePlateECUTag plate={plate} vehicle={vehicle}/>),
        },
        {
          title: "Status",
          dataIndex: "status",
            filters: Object.values(STATUS_LABEL).map((sl, i) => ({
                text: <Tag key={i} color={STATUS_LABEL[sl.status]?.color}>{STATUS_LABEL[sl.status]?.label}</Tag>,
                value: sl.status
            })),
            onFilter: (value, record) => record.status === Number(value),
            render: (data) => 
                <Tag color={STATUS_LABEL[data]?.color}>
                    {/* <Badge color={STATUS_LABEL[data]?.color} style={{ marginRight: '8px'}}/> */}
                    {STATUS_LABEL[data]?.label}
                </Tag>,
        },
        {
            title: "Devices",
            // ...getColumnSearchProps("Status", 'status', searchTextState, searchedColumnState),
            render: ({ gnss_status = 0, fuel_sensor = 0, mdvr = 0 }) => {

                const color = (status) => status === 1 ? 'green' : '#C8C8C8'

                return (
                    <div >
                        <SVG fill={color(gnss_status)} name='gps_sensor' size='2.5em'/>
                        <SVG fill={color(fuel_sensor)} name='fuel_sensor' size='2.5em'/>
                        <VideoCameraOutlined style={{ color: color(mdvr), fontSize: '1.5em',  position: 'absolute' }}/>
                    </div>
                )
            }

          },
        {
          title: "Vehicle Groups",
          dataIndex: "vhcgids",
          width: 250,
          render: (vhcgids) => {

            return (
              //   <>
              //     {   (allLabelHDLR(vhcgids, allVGIDs) || vhcgids.includes('ALL'))
              //         &&
              //         <Tag color='blue'>ALL</Tag>
              //         ||
                      vhcgids.map((vhcgid, i) => (
                          <Tag key={i} color={vehicleGroups.byID[vhcgid]?.color !== '#FFFFFF' ? vehicleGroups.byID[vhcgid]?.color : "blue"}>
                              {vehicleGroups.byID[vhcgid]?.name || 'ALL'}
                          </Tag>
                      ))
              //     }
              //   </>
            )
          },
          filters: allVGIDs.map((vgid, i) => ({
                text: <Tag key={i} color={vehicleGroups.byID[vgid]?.color}>{vehicleGroups.byID[vgid]?.name}</Tag>,
                value: vgid
            })),
          onFilter: (value, record) => Array.isArray(record.vhcgids) && record.vhcgids.includes(value)  
        }, 
        // {
        //   title: "Vehicle Name",
        //   dataIndex: "displayName",
        //   ...getColumnSearchProps("Vehicle Name", 'displayName', searchTextState, searchedColumnState, (plate, vehicle) => <VehiclePlateECUTag plate={plate} vehicle={vehicle}/>),
        // },
        {
          title: "Company",
          dataIndex: "company",
          ...getColumnSearchProps("Company", 'company', searchTextState, searchedColumnState, (plate, vehicle) => <VehiclePlateECUTag plate={plate} vehicle={vehicle}/>),
          render: (data) => users[data]?.name || "-"
        },
        {
          title: "Type",
          dataIndex: "type",
          filters: [ 'Bus', 'Four Wheel Drive', 'Motocar', 'Motocycle', 'Taxi', 'Truck', 'Van', 'Prime Mover', 'Others' ]
                    .map(tp => ({ text: tp, value: tp })),
          onFilter: (value, record) => record.type === value,
        },
        {
          title: "Model",
          dataIndex: "model",
          ...getColumnSearchProps("Model", "model", searchTextState, searchedColumnState),
        },
        {
          title: "Assigned GPS",
          dataIndex: "imei",
          isHidden: TEMPLATE.USER_ROLE.FILTER_OUT_ROLE.includes(curUserRole), //this column will be filtered out if user is fleetOwner
          ...getColumnSearchProps("Assigned GPS", 'imei', searchTextState, searchedColumnState),
        },
        {
          title: "Assigned MDVR",
          dataIndex: "mdvrid",
          isHidden: TEMPLATE.USER_ROLE.FILTER_OUT_ROLE.includes(curUserRole), //this column will be filtered out if user is fleetOwner
          ...getColumnSearchProps("Assigned MDVR", 'mdvrid', searchTextState, searchedColumnState),
          render: (data) => data || '-'
        },
        // {
        //     title: "Vehicle Package",
        //     dataIndex: "vpkgids",
        //     width: 250,
        //     // render: vehiclePackage => <VehiclePackageLabel vehiclePackage={vehiclePackage}/>
        //     render: odata => {

        //         const data = Array.isArray(odata) ? odata?.filter(d => d.includes('#')) : [odata] || []

        //         return (
        //             data?.map((vpkgid, i) => 
        //                 <Tag key={i} color={'blue'}>
        //                     {vehiclePackages[vpkgid]?.name}
        //                 </Tag>
        //             )
        //         )
        //     }
        //     //     allLabelHDLR(data, allVPKGIDs)
        //     //         &&
        //     //         <Tag color='blue'>ALL</Tag>
        //     //         ||
        //     // (
        //     //     Array.isArray(data)
        //     //     &&
        //     // )
        // },
        // {
        //     title: "Vehicle Package Status",
        //     dataIndex: "vehiclePackage",
        //     filters: Object.keys(TEMPLATE.PACKAGE.VEHICLE_PACKAGE_STATUS_CODE).map(code=> (
        //       {
        //           text: TEMPLATE.PACKAGE.VEHICLE_PACKAGE_STATUS_CODE[code],
        //           value: code,
        //       }
        //     )),
        //     onFilter: (value, record) => record.vehiclePackage && Number(record.vehiclePackage.status) === Number(value),
        //     render: vehiclePackage => <VehiclePackageStatus vehiclePackage={vehiclePackage}/>
        // },
        {
            title: "Registration Date",
            dataIndex: "registeredAt",
            // defaultSortOrder: "ascend",
            width: 180,
            sorter: (a, b) => a.registeredAt - b.registeredAt,
            render: registeredAt => parseDate(Number(registeredAt)),
          },
          {
            title: "Last Updated By",
            defaultSortOrder: "descend",
            // dataIndex: 'updatedAt',
            width: 200,
            sorter: (a, b) => a.updatedAt - b.updatedAt,
            render: (data) => {
                const name = users[data.createdBy]?.name

                return (
                    <>
                        <>{name}</><br/>
                        <>{parseDate(Number(data.updatedAt))}</>
                    </>
                )
            }
          },
        {
            title: "Created By",
            width: 200,
            // dataIndex: 'createdAt',
            sorter: (a, b) => a.createdAt - b.createdAt,
            render: (data) => {
                const name = users[data.createdBy]?.name

                return (
                    <>
                        <>{name}</><br/>
                        <>{parseDate(Number(data.createdAt))}</>
                    </>
                )
            }
          },
        // {
        //     title: "QR",
        //     width: 90,
        //     render: (data) => {

        //         return (
        //             <>
        //                 <QrcodeOutlined onClick={() => setQRContent(`${FMS_V3_FE_LIVE_TRACKING_URL}pretrip?plate=${data.plate}`)}/>
        //             </>
        //         )
        //     }
        //   },
        {
            title: "Actions",
            fixed: 'right',
            render: data => {

                // delete data.fuelProfile?.createdAt
                // delete data.fuelProfile?.updatedAt

                const newData = {
                    vehicle: {
                        vid: data.vid,
                        status: data.status,
                        plate: data.plate,
                        displayName: data.displayName,
                        brand: data.brand || '',
                        model: data.model,
                        type: data.type,
                        registeredAt: data.registeredAt || 0,
                        chassisNumber: data.chassisNumber,
                        engineNumber: data.engineNumber,
                        fuel_type: data.fuel_type || '',
                        loadedWeight: data.loadedWeight,
                        unloadedWeight: data.unloadedWeight,
                        engineCC: 1000,
                        imei: data.imei || data?.dvid?.split('#')[1] || '',
                        dvid: data.dvid
                    },
                    ...data.fuelProfile && {
                        fuelProfile: {
                            ...data.fuelProfile,
                            tankNum: 1
                        },
                    },
                    imei: data.imei || data?.dvid?.split('#')[1] || '',
                    vhcgids: data.vhcgids,
                    vpkgids: data.vpkgids,
                    company: data.company || uid,
                    ruletid: data.ruletid || `rulet#${uid}`,
                    uid: uid
                }

                const items = [
                    {
                        key: '1',
                        label: 
                            <span 
                                className="ButtonLink"
                                aria-hidden="true"
                                onClick = {() => navigate(`/update/vehicle`, {state: { data: { ...data, title: 'Edit' } }})}
                            >
                                Edit
                            </span>
                    },
                    {
                        key: '2',
                        label: 
                        <ModalStandard 
                            onClick={() => {
                                dispatch(REDUX_ACTIONS.v3_vehicles.update_vehicle_request({
                                    ...newData,
                                    vehicle: {
                                        ...newData.vehicle,
                                        status: 1
                                    },
                                    uid: uid
                                }))
                            }}
                            disabled={data.status === 1}
                            title={'Mark as active'}
                            content={'You are about to mark this vehicle as active.'}
                            subcontent={`${data.plate || '-'}`}
                            // icon={<></>}
                        >
                            Mark as active
                        </ModalStandard>
                    },
                    {
                        key: '3',
                        label: 
                        <ModalStandard 
                            onClick={() => {
                                dispatch(REDUX_ACTIONS.v3_vehicles.update_vehicle_request({
                                    ...newData,
                                    vehicle: {
                                        ...newData.vehicle,
                                        status: 0
                                    },
                                    uid: uid
                                }))
                            }}
                            disabled={data.status === 0}
                            title={'Mark as inactive'}
                            content={'You are about to mark this vehicle as inactive.'}
                            subcontent={`${data.plate || '-'}`}
                            // icon={<></>}
                        >
                            Mark as inactive
                        </ModalStandard>
                    },
                    {
                        key: '4',
                        label: 
                            <span 
                                className="ButtonLink"
                                aria-hidden="true"
                                onClick = {() => setQRContent({ link: `${FMS_V3_FE_LIVE_TRACKING_URL}pretrip?plate=${data.plate}`, plate: data.plate, model: data.model })}
                            >
                                View QR
                            </span>
                    },
                ]

                return (
                    <Flex gap={'1em'}>
                        <Dropdown menu={{ items }}>
                            <EditOutlined />
                        </Dropdown>
                        {/* <DownloadOutlined onClick={() => pdf_handler.exportHiddenQR(`${FMS_V3_FE_LIVE_TRACKING_URL}pretrip?plate=${data.plate}`)} /> */}
                    </Flex>
                )

            }
          }
      ];

      useEffect(() => {
        setIsLoaded(Object.values(vehicleStaticses).length > 0 || (Object.values(vehicleStaticses).length === 0 && !loading));
        if (prevVehicles !== vehicleStaticses) {
            refreshDataSrc();
        }
    }, [vehicleStaticses]);

    const fileInputRef = useRef(null);

    const handleFileChange = (event) => {

        const file = event.target.files[0];

        if (file) {
            uploadHDLR.decodeFile(file, (d) => {
                const rData = xlsx_handler.readXLSXFile(d); // read data

                const testData = {
                        "vehicle": {
                        "displayName": "EFEIOI4535", 
                        "plate": "EFEIOI4535", 
                        "model": "Confero S",
                        "type": "Truck",
                        "registeredAt": 1743699600000,
                        "engineNumber": "909854089",
                        "fuel_type": "ron_97",
                        "loadedWeight": 100,
                        "unloadedWeight": 19,
                        "engineCC": 13074
                        },
                        "fuelProfile": {
                        "tankNum": 1,
                        "0_max": 100,
                        "0_min": 10,
                        "0_sensorType": 'dipstick',
                        "0_model": 'dipstick',
                        "0_capacity": 100,
                        "0_operator": 'V',
                        "0_deviceParam": 'ai_1'
                        },
                        "imei": "19029348908034",
                    "vhcgids": [
                        "vhcg#u#1734496225995-nOZ8nIs9IDhd"
                    ],
                    "vpkgids": [
                        "vpkg#GP011"
                    ],
                    "company": "u#CnOG2vSf38Xn28w3x4AboTCD4ch2",
                    "uid": "u#1734496225995-nOZ8nIs9IDhd"
                    }
                
                const rDataF = rData.map(d => {

                    return {
                        vehicle: {
                            ...testData.vehicle,
                            status: 1,
                            plate: d['Vehicle Plate*'],
                            displayName: d['Vehicle Name*'],
                            type: d['Type'],
                            model: d['Model'],
                            chassisNumber: Number(d['Vehicle Chassis No']) || 0,
                            engineNumber: Number(d["Vehicle Engine No"]) || 0,
                            unloadedWeight: Number(d["Unloaded Weight"]) || 0,
                            loadedWeight: Number(d["Loaded Weight"]) || 0,
                        },
                        imei: ''
                    }
                })

                delete testData.vehicle
                delete testData.fuelProfile

                const names1 = new Set(rDataF.map(x => x.vehicle.plate))
                const hasNoDuplicate = !dataSource.some(d => names1.has(d.plate));
                const isNotDuplicated = (rDataF.length === new Set(rDataF.map(x => x.vehicle.plate)).size) && hasNoDuplicate


                if(isNotDuplicated) {
                    dispatch(REDUX_ACTIONS.v3_vehicles.create_vehicles_request({
                        vehicles: rDataF,
                        vhcgids: [ `vhcg#${uid || ''}` ],
                        uid,
                        company: uid,
                        // fuelProfile: {
                        //     ...testData.fuelProfile
                        // }
                    }))
                    event.target.value = null
                } else {
                    message.warning('Duplicated Vehicle Plate detected. Please change Vehicle Plate into unique value!')
                }

            });
        }
    };
    
    const BulkCreateDriverItems = [
        {
            key: '1',
            label: 
            <>
                <span 
                    className="ButtonLink"
                    aria-hidden="true"
                    onClick = {() => fileInputRef.current?.click()}
                >
                    Upload File
                </span>
                <input 
                    type="file" 
                    ref={fileInputRef} 
                    accept=".xlsx,.xls,.csv"
                    onChange={handleFileChange} 
                    style={{ display: "none" }} 
                />
            </>
        },
        {
            key: '2',
            label: 
                <span 
                    className="ButtonLink"
                    aria-hidden="true"
                    onClick = {() => templateHDLR.getVehicleTemplateXLSXFromS3()}
                >
                    Download Template
                </span>
        },
    ]

    return (
        // <div style = {{ display: "flex", flex: 1 }}>
        <div >
            {
                qrContent
                &&
                <Modal
                    open={qrContent?.link}
                    onCancel={() => setQRContent(null)}
                    className='modal-container'
                    closable={true}
                    closeIcon={<CloseOutlined style={{ color: '#fff'}} onClick={() => setQRContent(null)} />}
                    footer={false}
                    width={400}
                    centered
                    title={
                        <div style={{ lineHeight: 1, color: '#fff', zIndex: 9999}}>
                            <h3>QR Code</h3>
                            <h5>{qrContent.plate} | {qrContent.model}</h5>
                        </div>
                    }
                    styles={{
                        header: {
                            backgroundColor: '#000',
                            padding: '1em'
                        },
                        body: {
                            borderRadius: 5,
                            padding: '.3em 2em 1.8em 2em',
                            textAlign: 'center'
                        },

                    }}
                >
                    <div id='jpg' style={{ padding: '2em 0'}}>
                        <h2>Scan to start checklist</h2>
                            <QRCode value={qrContent.link} style={{ margin: '0 auto'}}/>
                        <h4>{qrContent.link}</h4>
                    </div>

                    <Button 
                        className={styles["button-qr-main"]}
                        onClick={() => { 
                            navigator.clipboard.writeText(qrContent.link)
                            message.success('Link copied!')
                        }}
                    >
                        Copy URL
                    </Button>
                    <Button className={styles["button-qr"]} onClick={() => pdf_handler.exportToJPG('jpg', `${qrContent}.jpg`)}>Download JPG</Button>
                </Modal>
            }

            <div style={{ display: 'flex', gap: '7px', float: 'right', marginBottom: '15px'}}>
                <Dropdown menu={{ items: BulkCreateDriverItems }}>
                    <Button>+ Bulk Create Vehicles</Button>
                </Dropdown>
                <PrimaryButton htmlType={'submit'} style={{ float: 'right', marginBottom: '15px' }} onClick={() => navigate (`/create/vehicle`)}>+ Create vehicle</PrimaryButton>
            </div>
            {   !isLoaded ? 
                <Loading /> :
                dataSource.length > 0 ?
                    <Table
                        loading={loading}
                        columns={vehiclePanelColumns && vehiclePanelColumns.filter(c => !c.isHidden)}
                        dataSource={dataSource}
                        pagination={true}
                        scroll={{
                            y: window.innerHeight,
                            x: vehiclePanelColumns && vehiclePanelColumns.length * 180
                        }}
                    /> 
                :
                    <EmptyIndicator />
            }
        </div>
    )
}

export default VehiclePanel